/*
  assets/gtender-workspace-watch.js — GTENDER-WORKSPACE-FE-WS03
  Owner: GTender Pro Watch workspace panel only.
  Identity / plan authority remains LittleGWebSession -> Core -> gtender_account.
  Watch persistence remains native-subject scoped behind /v1/tender/watch-rules.
  Native alert delivery remains production-disabled until the backend scheduler gate is explicitly activated.
*/
(function () {
  'use strict';

  var VERSION = 'gtender-workspace-fe-ws03-02';
  var GLOBAL_KEY = '__GTENDER_WORKSPACE_WATCH_RUNTIME__';
  var ROOT_SELECTOR = '[data-gtender-dashboard-root][data-native-session-required]';
  var API_ORIGIN = 'https://api.glhksolution.com';
  var WATCH_URL = API_ORIGIN + '/v1/tender/watch-rules';
  var REQUEST_TIMEOUT_MS = 10000;
  var stateByRoot = new WeakMap();
  var EVENT_TYPES = Object.freeze([
    'tender_new',
    'addendum_detected',
    'closing_date_changed',
    'tender_cancelled',
    'tender_suspended',
    'deadline_approaching'
  ]);
  var ZH_CN = Object.freeze({
    '正在重新核驗 GTender Pro 權限…': '正在重新核验 GTender Pro 权限…',
    '監察規則可保存及管理；自動提醒排程目前仍為生產關閉狀態，未啟用前不會宣稱已發送提醒。': '监控规则可保存及管理；自动提醒排程目前仍为生产关闭状态，未启用前不会宣称已发送提醒。',
    '關鍵字：': '关键词：',
    '類別：': '类别：',
    '部門：': '部门：',
    '狀態：': '状态：',
    ' 日內': ' 日内',
    '未有條件': '暂无条件',
    '尚未建立監察規則': '尚未建立监控规则',
    '建立一個條件後，規則會保存到目前 native Pro 帳戶。': '建立一个条件后，规则会保存到当前 native Pro 账户。',
    'Tender 監察': 'Tender 监控',
    '啟用規則': '启用规则',
    '事件：': '事件：',
    '未指定事件類型': '未指定事件类型',
    '刪除規則': '删除规则',
    '工作區資料尚未完成遷移': '工作区数据尚未完成迁移',
    'Watch 暫時無法載入': 'Watch 暂时无法载入',
    '未完成 subject ownership rollout 前，不會推定或搬移舊資料。': '未完成 subject ownership rollout 前，不会推定或迁移旧数据。',
    '目前資料不會被當成空清單覆蓋。': '当前数据不会被当作空列表覆盖。',
    '正在載入監察規則…': '正在载入监控规则…',
    '未進行任何 ownership 推定。': '未进行任何 ownership 推定。',
    '沒有修改追蹤設定。': '未修改任何 Watch 数据。',
    '已載入目前 native Pro 帳戶的 Watch 規則。': '已载入当前 native Pro 账户的 Watch 规则。',
    '請至少輸入一個監察條件。': '请至少输入一个监控条件。',
    '正在保存監察規則…': '正在保存监控规则…',
    '未能保存規則；現有資料保持不變。': '未能保存规则；现有数据保持不变。',
    '監察規則已保存。': '监控规则已保存。',
    '正在更新…': '正在更新…',
    '未能更新；原設定已保留。': '未能更新；原设置已保留。',
    '規則設定已更新。': '规则设置已更新。',
    '正在刪除…': '正在删除…',
    '未能刪除；規則保持不變。': '未能删除；规则保持不变。',
    '監察規則已刪除。': '监控规则已删除。',
    '監察規則': '监控规则',
    '規則只屬於目前已驗證的 native Pro 帳戶。': '规则只属于当前已验证的 native Pro 账户。',
    '規則名稱（可選）': '规则名称（可选）',
    '關鍵字': '关键词',
    '類別': '类别',
    '部門': '部门',
    '招標狀態': '招标状态',
    '截止日距今天數': '截止日距今天数',
    '事件類型（可選）': '事件类型（可选）',
    '保存監察規則': '保存监控规则',
    '重新載入': '重新载入'
  });
  var EVENT_LABELS = Object.freeze({
    tender_new: ['新招標', '新招标', 'New tender'],
    addendum_detected: ['偵測到補充文件', '检测到补充文件', 'Addendum detected'],
    closing_date_changed: ['截止日期變更', '截止日期变更', 'Closing date changed'],
    tender_cancelled: ['招標取消', '招标取消', 'Tender cancelled'],
    tender_suspended: ['招標暫停', '招标暂停', 'Tender suspended'],
    deadline_approaching: ['接近截止', '临近截止', 'Deadline approaching']
  });

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].boot === 'function') {
    window[GLOBAL_KEY].boot(document);
    return;
  }

  function list(scope, selector) {
    var target = scope || document;
    var output = [];
    if (target.matches && target.matches(selector)) output.push(target);
    if (target.querySelectorAll) Array.prototype.push.apply(output, target.querySelectorAll(selector));
    return output;
  }

  function clean(value) { return String(value == null ? '' : value).trim(); }
  function localeFamily(root) {
    var locale = clean(root && root.getAttribute('data-locale')) || clean(document.documentElement.lang) || 'en';
    locale = locale.toLowerCase();
    if (locale === 'zh-cn' || locale === 'zh-hans' || locale === 'zh-sg') return 'zh-CN';
    if (locale.indexOf('zh') === 0) return 'zh-TW';
    return 'en';
  }
  function copy(root, zh, en) {
    var family = localeFamily(root);
    if (family === 'zh-CN') return ZH_CN[zh] || zh;
    return family === 'zh-TW' ? zh : en;
  }
  function eventTypeLabel(root, eventType) {
    var labels = EVENT_LABELS[eventType];
    if (!labels) return String(eventType || '').replace(/_/g, ' ');
    var family = localeFamily(root);
    return family === 'zh-CN' ? labels[1] : family === 'zh-TW' ? labels[0] : labels[2];
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }

  function workspace() {
    return window.GTenderWorkspace && typeof window.GTenderWorkspace.getPanelHost === 'function'
      ? window.GTenderWorkspace
      : null;
  }

  function requestJson(root, state, url, options) {
    var session = window.LittleGWebSession;
    if (!session || typeof session.authenticatedFetch !== 'function') {
      return Promise.resolve({ ok: false, status: 0, code: 'native_session_unavailable', data: {} });
    }
    if (state.requestController) state.requestController.abort();
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    state.requestController = controller;
    var requestOptions = Object.assign({}, options || {});
    requestOptions.headers = Object.assign({ Accept: 'application/json' }, requestOptions.headers || {});
    if (controller) requestOptions.signal = controller.signal;
    var timeout = null;
    var deadline = new Promise(function (_, reject) {
      timeout = window.setTimeout(function () {
        if (controller) controller.abort();
        var error = new Error('GTender Watch request timed out.');
        error.code = 'gtender_watch_timeout';
        reject(error);
      }, REQUEST_TIMEOUT_MS);
    });
    return Promise.race([session.authenticatedFetch(url, requestOptions), deadline]).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        var data = payload && payload.data && typeof payload.data === 'object' ? payload.data : {};
        var code = clean(payload && payload.error && payload.error.code);
        return { ok: response.ok && payload && payload.success === true, status: response.status, code: code, data: data };
      });
    }).catch(function (error) {
      return { ok: false, status: 0, code: clean(error && error.code) || 'network_error', data: {} };
    }).finally(function () {
      if (timeout !== null) window.clearTimeout(timeout);
      if (state.requestController === controller) state.requestController = null;
    });
  }

  function setStatus(state, text, tone) {
    state.status.textContent = text || '';
    state.status.setAttribute('data-tone', tone || 'neutral');
  }

  function accessChanged(root, state) {
    var ws = workspace();
    if (ws) ws.disable(root, 'watch');
    state.loaded = false;
    state.rules = [];
    setStatus(state, copy(root, '正在重新核驗 GTender Pro 權限…', 'Revalidating GTender Pro access…'), 'warning');
    root.dispatchEvent(new CustomEvent('gtender-dashboard:access-refresh-required', { bubbles: true }));
  }

  function schedulerNotice(root) {
    var node = element('p', 'gtender-workspace-watch__notice', copy(
      root,
      '監察規則可保存及管理；自動提醒排程目前仍為生產關閉狀態，未啟用前不會宣稱已發送提醒。',
      'Watch rules can be saved and managed. Automated alert delivery remains production-disabled and no alert is claimed as sent until the scheduler is explicitly activated.'
    ));
    node.setAttribute('data-gtender-watch-scheduler-state', 'production-disabled');
    return node;
  }

  function formatCriteria(root, rule) {
    var parts = [];
    if (clean(rule.query_text)) parts.push(copy(root, '關鍵字：', 'Query: ') + clean(rule.query_text));
    if (clean(rule.category)) parts.push(copy(root, '類別：', 'Category: ') + clean(rule.category));
    if (clean(rule.department)) parts.push(copy(root, '部門：', 'Department: ') + clean(rule.department));
    if (clean(rule.tender_status)) parts.push(copy(root, '狀態：', 'Status: ') + clean(rule.tender_status));
    if (rule.deadline_days != null) parts.push(copy(root, '截止：', 'Deadline: ') + String(rule.deadline_days) + copy(root, ' 日內', ' days'));
    return parts.join(' · ') || copy(root, '未有條件', 'No criteria');
  }

  function render(root, state) {
    state.list.replaceChildren();
    state.count.textContent = String(state.rules.length);
    if (!state.rules.length) {
      var empty = element('div', 'gtender-workspace-watch__empty');
      empty.appendChild(element('h3', '', copy(root, '尚未建立監察規則', 'No watch rules yet')));
      empty.appendChild(element('p', '', copy(root, '建立一個條件後，規則會保存到目前 native Pro 帳戶。', 'Create a criterion and the rule will be stored under the current native Pro account.')));
      state.list.appendChild(empty);
      return;
    }

    state.rules.forEach(function (rule) {
      var id = clean(rule && rule.rule_id);
      if (!id) return;
      var card = element('article', 'gtender-workspace-watch__rule');
      card.setAttribute('data-gtender-watch-rule', id);
      var head = element('div', 'gtender-workspace-watch__rule-head');
      var title = element('div', '');
      title.appendChild(element('strong', '', clean(rule.name) || copy(root, 'Tender 監察', 'Tender watch')));
      title.appendChild(element('p', '', formatCriteria(root, rule)));
      head.appendChild(title);

      var toggleLabel = element('label', 'gtender-workspace-watch__toggle');
      var toggle = document.createElement('input');
      toggle.type = 'checkbox';
      toggle.checked = rule.enabled === true;
      toggle.setAttribute('data-gtender-watch-toggle', id);
      toggleLabel.appendChild(toggle);
      toggleLabel.appendChild(element('span', '', copy(root, '啟用規則', 'Rule enabled')));
      head.appendChild(toggleLabel);
      card.appendChild(head);

      var events = Array.isArray(rule.event_types) ? rule.event_types : [];
      card.appendChild(element('p', 'gtender-workspace-watch__events', events.length
        ? copy(root, '事件：', 'Events: ') + events.map(function (eventType) { return eventTypeLabel(root, eventType); }).join(', ')
        : copy(root, '未指定事件類型', 'No event types selected')));

      var actions = element('div', 'gtender-workspace-watch__actions');
      var remove = element('button', 'gtender-workspace-watch__button gtender-workspace-watch__button--danger', copy(root, '刪除規則', 'Delete rule'));
      remove.type = 'button';
      remove.setAttribute('data-gtender-watch-delete', id);
      actions.appendChild(remove);
      card.appendChild(actions);
      var error = element('p', 'gtender-workspace-watch__row-error', '');
      error.setAttribute('data-gtender-watch-row-error', id);
      error.setAttribute('aria-live', 'polite');
      card.appendChild(error);
      state.list.appendChild(card);
    });
  }

  function renderBlocked(root, state, migration) {
    state.list.replaceChildren();
    var box = element('div', 'gtender-workspace-watch__empty');
    box.appendChild(element('h3', '', migration
      ? copy(root, '工作區資料尚未完成遷移', 'Workspace ownership migration is pending')
      : copy(root, 'Watch 暫時無法載入', 'Watch is temporarily unavailable')));
    box.appendChild(element('p', '', migration
      ? copy(root, '未完成 subject ownership rollout 前，不會推定或搬移舊資料。', 'Legacy data is not assumed or moved before the subject-ownership rollout is complete.')
      : copy(root, '目前資料不會被當成空清單覆蓋。', 'Existing records are not being treated as an empty list.')));
    state.list.appendChild(box);
    state.count.textContent = '—';
  }

  function load(root, state, force) {
    if (!state.active || root.getAttribute('data-access-state') !== 'pro') return Promise.resolve(false);
    if (state.loading) return Promise.resolve(false);
    if (state.loaded && !force) return Promise.resolve(true);
    state.loading = true;
    setStatus(state, copy(root, '正在載入監察規則…', 'Loading watch rules…'), 'neutral');
    root.setAttribute('data-watch-workspace-state', 'loading');
    return requestJson(root, state, WATCH_URL, { method: 'GET' }).then(function (result) {
      if (!state.active || root.getAttribute('data-access-state') !== 'pro') return false;
      if (result.status === 401 || result.status === 403) {
        accessChanged(root, state);
        root.setAttribute('data-watch-workspace-state', 'access-changed');
        return false;
      }
      if (result.status === 409 && result.code === 'workspace_ownership_migration_required') {
        state.loaded = false;
        renderBlocked(root, state, true);
        setStatus(state, copy(root, '未進行任何 ownership 推定。', 'No ownership assumption was made.'), 'warning');
        root.setAttribute('data-watch-workspace-state', 'ownership-blocked');
        return false;
      }
      if (!result.ok || !Array.isArray(result.data.rules)) {
        state.loaded = false;
        renderBlocked(root, state, false);
        setStatus(state, copy(root, '沒有修改追蹤設定。', 'No watch settings were changed'), 'warning');
        root.setAttribute('data-watch-workspace-state', 'unavailable');
        return false;
      }
      state.rules = result.data.rules.slice(0, 200);
      state.loaded = true;
      render(root, state);
      setStatus(state, copy(root, '已載入目前 native Pro 帳戶的 Watch 規則。', 'Watch rules for the current native Pro account are loaded.'), 'success');
      root.setAttribute('data-watch-workspace-state', 'ready');
      return true;
    }).finally(function () { state.loading = false; });
  }

  function createRule(root, state) {
    if (state.saving) return;
    var form = state.form;
    var body = {
      name: clean(form.elements.name.value).slice(0, 120),
      query_text: clean(form.elements.query_text.value).slice(0, 240),
      category: clean(form.elements.category.value).slice(0, 120),
      department: clean(form.elements.department.value).slice(0, 180),
      tender_status: clean(form.elements.tender_status.value).slice(0, 60),
      deadline_days: clean(form.elements.deadline_days.value) || null,
      enabled: true,
      event_types: Array.prototype.slice.call(form.querySelectorAll('[name="event_types"]:checked')).map(function (node) { return node.value; })
    };
    if (!body.query_text && !body.category && !body.department && !body.tender_status && body.deadline_days == null) {
      setStatus(state, copy(root, '請至少輸入一個監察條件。', 'Enter at least one watch criterion.'), 'warning');
      form.elements.query_text.focus();
      return;
    }
    state.saving = true;
    state.submit.disabled = true;
    setStatus(state, copy(root, '正在保存監察規則…', 'Saving watch rule…'), 'neutral');
    requestJson(root, state, WATCH_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (result) {
      if (result.status === 401 || result.status === 403) return accessChanged(root, state);
      if (!result.ok || !result.data.rule) {
        setStatus(state, copy(root, '未能保存規則；現有資料保持不變。', 'Could not save the rule; existing data is unchanged.'), 'warning');
        return;
      }
      form.reset();
      state.loaded = false;
      setStatus(state, copy(root, '監察規則已保存。', 'Watch rule saved.'), 'success');
      return load(root, state, true);
    }).finally(function () {
      state.saving = false;
      state.submit.disabled = false;
    });
  }

  function rowError(state, id, text) {
    var node = state.host.querySelector('[data-gtender-watch-row-error="' + CSS.escape(id) + '"]');
    if (node) node.textContent = text || '';
  }

  function patchEnabled(root, state, id, enabled, control) {
    control.disabled = true;
    rowError(state, id, copy(root, '正在更新…', 'Updating…'));
    requestJson(root, state, WATCH_URL + '/' + encodeURIComponent(id), {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enabled: enabled })
    }).then(function (result) {
      if (result.status === 401 || result.status === 403) return accessChanged(root, state);
      if (!result.ok || !result.data.rule) {
        control.checked = !enabled;
        rowError(state, id, copy(root, '未能更新；原設定已保留。', 'Update failed; the previous setting was preserved.'));
        return;
      }
      var index = state.rules.findIndex(function (rule) { return clean(rule.rule_id) === id; });
      if (index >= 0) state.rules[index] = result.data.rule;
      render(root, state);
      setStatus(state, copy(root, '規則設定已更新。', 'Rule setting updated.'), 'success');
    }).finally(function () { if (control.isConnected) control.disabled = false; });
  }

  function deleteRule(root, state, id, button) {
    if (state.deleting.has(id)) return;
    state.deleting.add(id);
    button.disabled = true;
    rowError(state, id, copy(root, '正在刪除…', 'Deleting…'));
    requestJson(root, state, WATCH_URL + '/' + encodeURIComponent(id), { method: 'DELETE' }).then(function (result) {
      if (result.status === 401 || result.status === 403) return accessChanged(root, state);
      if (!result.ok || result.data.deleted !== true) {
        rowError(state, id, copy(root, '未能刪除；規則保持不變。', 'Delete failed; the rule is unchanged.'));
        return;
      }
      state.rules = state.rules.filter(function (rule) { return clean(rule.rule_id) !== id; });
      render(root, state);
      setStatus(state, copy(root, '監察規則已刪除。', 'Watch rule deleted.'), 'success');
    }).finally(function () {
      state.deleting.delete(id);
      if (button.isConnected) button.disabled = false;
    });
  }

  function makeShell(root, host) {
    host.replaceChildren();
    var shell = element('div', 'gtender-workspace-watch');
    shell.setAttribute('data-gtender-workspace-watch', '');
    var header = element('div', 'gtender-workspace-watch__header');
    var copyNode = element('div', '');
    copyNode.appendChild(element('p', 'gtender-workspace-watch__eyebrow', 'GTender Pro'));
    copyNode.appendChild(element('h2', '', copy(root, '監察規則', 'Watch Rules')));
    copyNode.appendChild(element('p', '', copy(root, '規則只屬於目前已驗證的 native Pro 帳戶。', 'Rules belong only to the currently verified native Pro account.')));
    header.appendChild(copyNode);
    var count = element('strong', 'gtender-workspace-watch__count', '—');
    header.appendChild(count);
    shell.appendChild(header);
    shell.appendChild(schedulerNotice(root));

    var status = element('p', 'gtender-workspace-watch__status', '');
    status.setAttribute('aria-live', 'polite');
    shell.appendChild(status);

    var form = element('form', 'gtender-workspace-watch__form');
    form.setAttribute('data-gtender-watch-form', '');
    form.noValidate = true;
    [
      ['name', copy(root, '規則名稱（可選）', 'Rule name (optional)'), 'text'],
      ['query_text', copy(root, '關鍵字', 'Query'), 'search'],
      ['category', copy(root, '類別', 'Category'), 'text'],
      ['department', copy(root, '部門', 'Department'), 'text'],
      ['tender_status', copy(root, '招標狀態', 'Tender status'), 'text'],
      ['deadline_days', copy(root, '截止日距今天數', 'Deadline within days'), 'number']
    ].forEach(function (field) {
      var label = element('label', 'gtender-workspace-watch__field');
      label.appendChild(element('span', '', field[1]));
      var input = document.createElement('input');
      input.name = field[0];
      input.type = field[2];
      if (field[0] === 'deadline_days') { input.min = '0'; input.max = '365'; input.inputMode = 'numeric'; }
      label.appendChild(input);
      form.appendChild(label);
    });

    var events = element('fieldset', 'gtender-workspace-watch__events-field');
    events.appendChild(element('legend', '', copy(root, '事件類型（可選）', 'Event types (optional)')));
    EVENT_TYPES.forEach(function (eventType) {
      var label = element('label', 'gtender-workspace-watch__event-option');
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.name = 'event_types';
      input.value = eventType;
      if (eventType === 'tender_new' || eventType === 'addendum_detected' || eventType === 'closing_date_changed' || eventType === 'deadline_approaching') input.checked = true;
      label.appendChild(input);
      label.appendChild(element('span', '', eventTypeLabel(root, eventType)));
      events.appendChild(label);
    });
    form.appendChild(events);

    var submit = element('button', 'gtender-workspace-watch__button gtender-workspace-watch__button--primary', copy(root, '保存監察規則', 'Save watch rule'));
    submit.type = 'submit';
    form.appendChild(submit);
    shell.appendChild(form);

    var toolbar = element('div', 'gtender-workspace-watch__toolbar');
    var refresh = element('button', 'gtender-workspace-watch__button', copy(root, '重新載入', 'Refresh'));
    refresh.type = 'button';
    refresh.setAttribute('data-gtender-watch-refresh', '');
    toolbar.appendChild(refresh);
    shell.appendChild(toolbar);
    var listNode = element('div', 'gtender-workspace-watch__list');
    shell.appendChild(listNode);
    host.appendChild(shell);
    return { shell: shell, count: count, status: status, form: form, submit: submit, list: listNode };
  }

  function activate(root, state) {
    var ws = workspace();
    if (!ws || root.getAttribute('data-access-state') !== 'pro') return;
    ws.enable(root, 'watch');
    if (root.getAttribute('data-workspace-tab') === 'watch') load(root, state, false);
  }

  function invalidate(root, state) {
    state.loaded = false;
    state.rules = [];
    if (state.requestController) state.requestController.abort();
    var ws = workspace();
    if (ws) ws.disable(root, 'watch');
    state.list.replaceChildren();
    state.count.textContent = '—';
    setStatus(state, '', 'neutral');
    root.removeAttribute('data-watch-workspace-state');
  }

  function mount(root) {
    if (!root || stateByRoot.has(root)) return;
    var ws = workspace();
    if (!ws) return;
    var host = ws.getPanelHost(root, 'watch');
    if (!host) return;
    var ui = makeShell(root, host);
    var state = {
      active: true,
      controller: new AbortController(),
      requestController: null,
      host: host,
      shell: ui.shell,
      count: ui.count,
      status: ui.status,
      form: ui.form,
      submit: ui.submit,
      list: ui.list,
      rules: [],
      loaded: false,
      loading: false,
      saving: false,
      deleting: new Set()
    };
    stateByRoot.set(root, state);
    root.setAttribute('data-watch-workspace-owner', VERSION);

    state.form.addEventListener('submit', function (event) { event.preventDefault(); createRule(root, state); }, { signal: state.controller.signal });
    state.shell.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('button') : null;
      if (!target || !state.host.contains(target)) return;
      if (target.matches('[data-gtender-watch-refresh]')) { event.preventDefault(); state.loaded = false; load(root, state, true); return; }
      var id = clean(target.getAttribute('data-gtender-watch-delete'));
      if (id) { event.preventDefault(); deleteRule(root, state, id, target); }
    }, { signal: state.controller.signal });
    state.shell.addEventListener('change', function (event) {
      var control = event.target;
      if (!control || !control.matches('[data-gtender-watch-toggle]')) return;
      var id = clean(control.getAttribute('data-gtender-watch-toggle'));
      if (id) patchEnabled(root, state, id, control.checked, control);
    }, { signal: state.controller.signal });
    root.addEventListener('gtender-dashboard:pro-ready', function () { activate(root, state); }, { signal: state.controller.signal });
    root.addEventListener('gtender-dashboard:access-invalidated', function () { invalidate(root, state); }, { signal: state.controller.signal });
    root.addEventListener('gtender-workspace:tabchange', function (event) {
      if (event && event.detail && event.detail.tab === 'watch') load(root, state, false);
    }, { signal: state.controller.signal });
    activate(root, state);
  }

  function destroy(root) {
    var state = root ? stateByRoot.get(root) : null;
    if (!state) return;
    state.active = false;
    if (state.requestController) state.requestController.abort();
    state.controller.abort();
    var ws = workspace();
    if (ws) ws.disable(root, 'watch');
    state.host.replaceChildren();
    root.removeAttribute('data-watch-workspace-owner');
    root.removeAttribute('data-watch-workspace-state');
    stateByRoot.delete(root);
  }

  function boot(scope) {
    var target = scope || document;
    list(target, ROOT_SELECTOR).forEach(mount);
  }

  function destroyAll(scope) {
    var target = scope || document;
    list(target, ROOT_SELECTOR).forEach(destroy);
  }

  document.addEventListener('shopify:section:load', function () { window.setTimeout(function () { boot(document); }, 0); });
  document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target || document); });
  window.addEventListener('pageshow', function () { boot(document); });

  var api = Object.freeze({ version: VERSION, boot: boot, destroy: destroyAll, load: load });
  window[GLOBAL_KEY] = api;
  window.GTenderWorkspaceWatch = api;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
})();
